import { PropsWithChildren } from 'react';
import Container, { ContainerProps } from '@mui/material/Container';
import Grid, { GridProps } from '@mui/material/Grid';

type Props = PropsWithChildren<
  {
    containerProps?: Partial<ContainerProps>;
    gridContainerProps?: GridProps;
  } & GridProps
>;

const GridColumnLayout: React.FC<Props> = ({
  containerProps,
  gridContainerProps,
  children,
  ...gridProps
}) => {
  return (
    <Container maxWidth={containerProps?.maxWidth ?? 'xl'} {...containerProps}>
      <Grid {...gridContainerProps} container>
        <Grid {...gridProps}>{children}</Grid>
      </Grid>
    </Container>
  );
};
export default GridColumnLayout;
